import HNSColors from "../../../../../ui library/HNSColors";
import ProviderDetail from "../provider-details/ProviderDetail";

export default function LeftPanel() {
  return (
    <div
      className="min-h-0 w-2/6 overflow-y-auto shadow-md [&::-webkit-scrollbar-thumb]:bg-blue-700 [&::-webkit-scrollbar]:[width:6px]"
      style={{ borderRadius: "14px", backgroundColor: HNSColors.neutrals[900] }}
    >
      <ProviderDetail />
    </div>
  );
}
